import { useQuery } from "react-query";
import axios, { AxiosResponse } from "axios";

type NationalInsuraceApiResponse = {
  dato: string;
  grunnbeloep: number;
  grunnbeloepPerMaaned: number;
  gjennomsnittPerAar: number;
  omregningsfaktor: number;
  virkningstidspunktForMinsteinntekt: string;
};

export const useNationalInsuranceBasicAmount = () => {
  const retrieveNationalInsuranceBasicAmount = async (): Promise<number> => {
    const response: AxiosResponse<NationalInsuraceApiResponse> =
      await axios.get<NationalInsuraceApiResponse>(
        "https://g.nav.no/api/v1/grunnbeloep",
      );

    return response.data.grunnbeloep;
  };

  return useQuery<number, Error>(
    "nationalInsuranceBasicAmount",
    retrieveNationalInsuranceBasicAmount,
    {
      initialData: 0,
      retry: 3,
      refetchOnWindowFocus: false,
    },
  );
};
